/*
  ============================================================================
  Analog & Grit — Home header scroll state
  Dwell drops the solid header background the instant you start scrolling. We
  keep the home header transparent over the hero and only switch it solid once
  the hero has scrolled past the nav — i.e. when New Arrivals reaches the top.

  - `.ag-header--scroll-managed` marks the header as managed by this script so
    the CSS override only applies on the home page (the class is added here).
  - `.ag-header--solid` is toggled on/off as the hero crosses the nav line.

  ag-header.css forces the transparent look while `--solid` is ABSENT, even
  though Dwell sets data-sticky-state="active".
  ============================================================================
*/
(() => {
  const header = document.querySelector('header-component[transparent]');
  const main = document.getElementById('MainContent');
  if (!header || !main) return;

  // The hero is the first content section on the home page; New Arrivals
  // follows it. The header turns solid once the hero clears the nav.
  const hero = main.querySelector(':scope > .shopify-section');
  if (!hero) return;

  header.classList.add('ag-header--scroll-managed');

  const SOLID_CLASS = 'ag-header--solid';
  let observer = null;

  const build = () => {
    if (observer) observer.disconnect();

    // Push the observer's top edge down by the nav height so the switch
    // happens exactly when the hero's bottom passes below the nav.
    const headerHeight = Math.round(header.getBoundingClientRect().height);

    observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return;
        // Hero still visible below the nav → transparent. Hero gone → solid.
        header.classList.toggle(SOLID_CLASS, !entry.isIntersecting);
      },
      { rootMargin: `-${headerHeight}px 0px 0px 0px`, threshold: 0 }
    );

    observer.observe(hero);
  };

  build();

  // The nav height can change across breakpoints; rebuild the observer so the
  // switch point stays aligned with the bottom of the nav.
  let resizeRaf = null;
  window.addEventListener(
    'resize',
    () => {
      if (resizeRaf !== null) return;
      resizeRaf = requestAnimationFrame(() => {
        resizeRaf = null;
        build();
      });
    },
    { passive: true }
  );
})();
